<div class="row">
  <div class="col-12">
    <div class="content-header">Helper Classes</div>
  </div>
</div>
<!-- Borders -->
<section id="borders">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Borders</h4>
        </div>
        <div class="card-content">
          <!--Add borders-->
          <div class="card-body">
            <div class="card-text my-1">
              <p class="bd-lead">Use border utilities to quickly style the border and border-radius of an element. Great for images, buttons, or any other element.</p>
              <h6 class="my-1">Add border</h6>
              <p>Add one of these to class to add border on the required side.</p>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>Classes</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>.border</code></td>
                  <td>Add solid border of 1px on each side.</td>
                </tr>
                <tr>
                  <td><code>.border-&#123;top/bottom/left/right&#125;</code></td>
                  <td>Add solid border top/bottom/left/right of 1px.</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--/Add borders-->

          <!--Remove borders-->
          <div class="card-body">
            <div class="card-text my-1">
              <h6 class="my-1">Remove border</h6>
              <p>Add one of these to class to remove border on the required side.</p>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>Classes</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>.border-0</code></td>
                  <td>Remove border from all side.</td>
                </tr>
                <tr>
                  <td><code>.border-&#123;top/bottom/left/right&#125;-0</code></td>
                  <td>Remove border from the top/bottom/left/right side.</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--/Remove borders-->

          <!--Border widths-->
          <div class="card-body">
            <div class="card-text my-1">
              <h6 class="my-1">Border widths</h6>
              <p>Add one of these to class to change border width on the required side.</p>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>Classes</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>.border-&#123;2/3&#125;</code></td>
                  <td>Change border width to 2px/3px on each side.</td>
                </tr>
                <tr>
                  <td><code>.border-&#123;side&#125;-&#123;size&#125;</code></td>
                  <td>Change border width on given side (top, bottom, left, right) of given size (2px, 3px, ...).</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--/Border width-->

          <!--Border color-->
          <div class="card-body">
            <div class="card-text my-1">
              <h6 class="my-1">Border color</h6>
              <p>Change the border color using utilities built on our theme colors. For more border color related options please check color palette pages.</p>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>Classes</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>.border.border-&#123;color&#125;</code></td>
                  <td>Add colored border to all side. Color can be primary, success, danger, warning, info, secondary light, dark, white.</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--/Border color-->

          <!--Border-radius-->
          <div class="card-body">
            <div class="card-text my-1">
              <h6 class="my-1">Border-radius</h6>
              <p>Add classes to an element to easily round its corners.</p>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>Classes</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>.rounded</code></td>
                  <td>Add round corners border to all side.</td>
                </tr>
                <tr>
                  <td><code>.rounded-&#123;side&#125;</code></td>
                  <td>Add round corners border to the given side only (top, bottom, left, right).</td>
                </tr>
                <tr>
                  <td><code>.rounded-circle</code></td>
                  <td>Create round circle border.</td>
                </tr>
                <tr>
                  <td><code>.rounded-0</code></td>
                  <td>Remove border corner from the all side.</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--/Border-radius-->


          <!--Remove border radius-->
          <div class="card-body">
            <div class="card-text my-1">
              <h6 class="my-1">Remove border radius</h6>
              <p>Add one of these to class to remove border radius on the required side.</p>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table mb-0">
              <thead>
                <tr>
                  <th>Classes</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>.no-border-&#123;top/bottom&#125;-radius</code></td>
                  <td>Remove border radius from top / bottom side.</td>
                </tr>
                <tr>
                  <td><code>.no-border-&#123;top/bottom&#125;-&#123;left/right&#125;-radius</code></td>
                  <td>Remove top / bottom border radius from left / right side.</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--/Remove borders-->
        </div>
      </div>
    </div>
  </div>
</section>
<!--/ Borders-->

<!--Clearfix-->
<section id="clearfix">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Clearfix</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="card-text my-1">
              <p>Quickly and easily clear floated content within a container by adding a clearfix utility.</p>
              <p>Easily clear <code>float</code>s by adding <code>.clearfix</code><strong> to the parent element</strong>. Can also be used as a mixin.</p>
            </div>
            <pre class="language-markup"><code class="language-markup">&lt;div class="clearfix"&gt;...&lt;/div&gt;
</code></pre>
      <pre class="language-css"><code class="language-css">// Mixin itself
@mixin clearfix() &#123;
    &::after &#123;
        display: block;
        content: "";
        clear: both;
    &#125;
&#125;

// Usage as a mixin
.element &#123;
    @include clearfix;
&#125;;
</code></pre>
            <p class="py-1">The following example shows how the clearfix can be used. Without the clearfix the wrapping div would not span around the buttons which would cause a broken layout.</p>
            <div class="my-3">
              <div class="bg-info clearfix">
                <button type="button" class="btn btn-danger float-left">Example Button floated left</button>
                <button type="button" class="btn btn-dark float-right">Example Button floated right</button>
              </div>
            </div>
            <pre class="language-markup"><code class="language-markup">&lt;div class="bg-info clearfix"&gt;
    &lt;button type="button" class="btn btn-danger float-left"&gt;Example Button floated left&lt;/button&gt;
    &lt;button type="button" class="btn btn-dark float-right"&gt;Example Button floated right&lt;/button&gt;
&lt;/div&gt;
</code></pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--/Clearfix-->

<!--Close icon-->
<section id="close-icon">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Close icon</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="card-text my-1">
              <p>Use a generic close icon for dismissing content like modals and alerts.</p>
              <p><strong>Be sure to include text for screen readers</strong>, as we’ve done with <code>aria-label</code>.</p>
            </div>
            <div class="d-flex">
              <button type="button" class="close" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <pre class="language-markup"><code class="language-markup">&lt;button type="button" class="close" aria-label="Close"&gt;
    &lt;span aria-hidden="true"&gt;&times;&lt;/span&gt;
&lt;/button&gt;
</code></pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--/Close icon-->

<!-- Display property -->
<section id="display-property">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Display property</h4>
        </div>
        <div class="card-content">
          <!--Display-->
          <div class="card-body">
            <div class="card-text">
              <p>Quickly and responsively toggle the display value of components and more with our display utilities. Includes support for some of the more common values, as well as some extras for controlling display when printing.</p>
              <h6 class="my-1">Common display values</h6>
              <p>The <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/display"><code>display</code> property</a> accepts a handful of values and we support many of them with utility classes. We purposefully don’t provide every value as a utility, so here’s what we support:</p>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>Classes</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>.d-none</code></td>
                  <td>Forces the element to hide on all viewports.</td>
                </tr>
                <tr>
                  <td><code>.d-inline</code></td>
                  <td>Forces the element to behave like an inline element.</td>
                </tr>
                <tr>
                  <td><code>.d-inline-block</code></td>
                  <td>Forces the element to behave like an inline-block element.</td>
                </tr>
                <tr>
                  <td><code>.d-block</code></td>
                  <td>Forces the element to behave like an block element.</td>
                </tr>
                <tr>
                  <td><code>.d-table</code></td>
                  <td>Forces the element to behave like <code>&lt;table&gt;</code> element.</td>
                </tr>
                <tr>
                  <td><code>.d-table-cell</code></td>
                  <td>Forces the element to behave like <code>&lt;td&gt;</code> element.</td>
                </tr>
                <tr>
                  <td><code>.d-flex</code></td>
                  <td>Forces the element as a block-level flex container.</td>
                </tr>
                <tr>
                  <td><code>.d-inline-flex</code></td>
                  <td>Forces the element as an inline-level flex container.</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-body">
            <div class="card-text">
              <p>Put them to use by applying any of the classes to an element of your choice. For example, here’s how youcould use the inline, block, or inline-block utilities (the same applies to the other classes).</p>
              <div class="my-3">
                <div class="d-inline bg-success p-1 mr-2 white">d-inline</div>
                <div class="d-inline bg-success p-1 white">d-inline</div>
              </div>
              <pre class="language-markup"><code class="language-markup">&lt;div class="d-inline bg-success"&gt;d-inline&lt;/div&gt;
&lt;div class="d-inline bg-success"&gt;d-inline&lt;/div&gt;
</code></pre>
              <div class="my-3">
                <span class="d-block bg-primary p-1 white">d-block</span>
              </div>
              <pre class="language-markup"><code class="language-markup">&lt;span class="d-block bg-primary"&gt;d-block&lt;/span&gt;
</code></pre>
              <div class="my-3">
                <div class="d-inline-block bg-warning p-1 mr-2 white">d-inline-block</div>
                <div class="d-inline-block bg-warning p-1 white">d-inline-block</div>
              </div>
              <pre class="language-markup"><code class="language-markup">&lt;div class="d-inline-block bg-warning"&gt;d-inline-block&lt;/div&gt;
&lt;div class="d-inline-block bg-warning"&gt;d-inline-block&lt;/div&gt;
</code></pre>
              <p>Responsive variations also exist for every single utility mentioned above.</p>
              <ul>
                <li><code>.d-none</code></li>
                <li><code>.d-inline</code></li>
                <li><code>.d-inline-block</code></li>
                <li><code>.d-block</code></li>
                <li><code>.d-table</code></li>
                <li><code>.d-table-cell</code></li>
                <li><code>.d-flex</code></li>
                <li><code>.d-inline-flex</code></li>
                <li><code>.d-&#123;breakPoint&#125;-none</code></li>
                <li><code>.d-&#123;breakPoint&#125;-inline</code></li>
                <li><code>.d-&#123;breakPoint&#125;-inline-block</code></li>
                <li><code>.d-&#123;breakPoint&#125;-block</code></li>
                <li><code>.d-&#123;breakPoint&#125;-table</code></li>
                <li><code>.d-&#123;breakPoint&#125;-table-cell</code></li>
                <li><code>.d-&#123;breakPoint&#125;-flex</code></li>
                <li><code>.d-&#123;breakPoint&#125;-inline-flex</code></li>
              </ul>
              <h6 class="my-1">Hiding Elements</h6>
              <p>For faster mobile-friendly development, use responsive display classes for showing and hiding elements by device. Avoid creating entirely different versions of the same site, instead hide element responsively for each screen size.</p>
              <p>To hide elements simply use the <code>.d-none</code> class or one of the <code>.d-&#123;sm,md,lg,xl&#125;-none</code> classes for any responsive screen variation.</p>
              <p>To show an element only on a given interval of screen sizes you can combine one <code>.d-*-none</code> class with a <code>.d-*-*</code> class, for example <code>.d-none.d-md-block.d-xl-none</code> will hide the element for all screen sizes except on medium and large devices.</p>
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Screen Size</th>
                      <th>Class</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Hidden on all</td>
                      <td><code>d-none</code></td>
                    </tr>
                    <tr>
                      <td>Hidden only on breakpoint size.</td>
                      <td><code>d-&#123;breakPoint&#125;-none d-&#123;breakPoint&#125;-block</code></td>
                    </tr>
                    <tr>
                      <td>Visible on all</td>
                      <td><code>d-block</code></td>
                    </tr>
                    <tr>
                      <td>Visible only on breakpoint size</td>
                      <td><code>d-&#123;breakPoint&#125;-none d-&#123;breakPoint&#125;-block </code></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <h6 class="my-1">Display in print</h6>
              <p>Change the <code>display</code> value of elements when printing with our print display utilities.</p>
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Class</th>
                      <th>Print style</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><code>.d-print-block</code></td>
                      <td>Applies <code>display: block</code> to the element when printing</td>
                    </tr>
                    <tr>
                      <td><code>.d-print-inline</code></td>
                      <td>Applies <code>display: inline</code> to the element when printing</td>
                    </tr>
                    <tr>
                      <td><code>.d-print-inline-block</code></td>
                      <td>Applies <code>display: inline-block</code> to the element when printing
                      </td>
                    </tr>
                    <tr>
                      <td><code>.d-print-none</code></td>
                      <td>Applies <code>display: none</code> to the element when printing</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!--/Display-->
        </div>
      </div>
    </div>
  </div>
</section>


<!--Embeds-->
<section id="embeds">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Embeds</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="card-text">
              <p>Create responsive video or slideshow embeds based on the width of the parent by creating an intrinsic ratio that scales on any device.</p>
              <p>Rules are directly applied to <code>&lt;iframe&gt;</code>, <code>&lt;embed&gt;</code>, <code>&lt;video&gt;</code>, and <code>&lt;object&gt;</code> elements; optionally use an explicit descendant class <code>.embed-responsive-item</code> when you want to match the styling for other attributes.</p>
              <p><strong>Pro-Tip!</strong> You don’t need to include <code>frameborder="0"</code> in your <code>&lt;iframe&gt;</code>s as we override that for you.</p>
              <h6 class="my-1">Example</h6>
              <p>Wrap any embed like an <code>&lt;iframe&gt;</code> in a parent element with <code>.embed-responsive</code> and an aspect ratio. The <code>.embed-responsive-item</code> isn’t strictly required, but we encourage it.</p>
              <div class="embed-responsive embed-responsive-16by9">
                <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/zpOULjyy-n8?rel=0" allowfullscreen=""></iframe>
              </div>
              <pre class="mt-3"><code class="language-markup">&lt;div class="embed-responsive embed-responsive-16by9"&gt;
    &lt;iframe class="embed-responsive-item" src="https://www.youtube.com/embed/zpOULjyy-n8?rel=0" allowfullscreen&gt;&lt;/iframe&gt;
&lt;/div&gt;
</code></pre>
              <h6 class="my-1">Aspect ratios</h6>
              <p>Aspect ratios can be customized with modifier classes.</p>
              <pre class="language-markup"><code class="language-markup">&lt;!-- 21:9 aspect ratio --&gt;
&lt;div class="embed-responsive embed-responsive-21by9"&gt;
    &lt;iframe class="embed-responsive-item" src="..."&gt;&lt;/iframe&gt;
&lt;/div&gt;

&lt;!-- 16:9 aspect ratio --&gt;
&lt;div class="embed-responsive embed-responsive-16by9"&gt;
    &lt;iframe class="embed-responsive-item" src="..."&gt;&lt;/iframe&gt;
&lt;/div&gt;

&lt;!-- 4:3 aspect ratio --&gt;
&lt;div class="embed-responsive embed-responsive-4by3"&gt;
    &lt;iframe class="embed-responsive-item" src="..."&gt;&lt;/iframe&gt;
&lt;/div&gt;

&lt;!-- 1:1 aspect ratio --&gt;
&lt;div class="embed-responsive embed-responsive-1by1"&gt;
    &lt;iframe class="embed-responsive-item" src="..."&gt;&lt;/iframe&gt;
&lt;/div&gt;
</code></pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--/Embeds-->

<!--Flex-->
<section id="flex">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Flex</h4>
        </div>
        <div class="card-content">
          <!--Enable flex behaviors-->
          <div class="card-body">
            <div class="card-text">
              <p class="bd-lead">Quickly manage the layout, alignment, and sizing of grid columns, navigation, components, and more with a full suite of responsive flexbox utilities. For more complex implementations, custom CSS may be necessary.</p>
              <h6 id="enable-flex-behaviors" class="my-1">Enable flex behaviors</h6>
              <p>Apply <code>display</code> utilities to create a flexbox container and transform <strong>direct children elements</strong> into flex items. Flex containers and items are able to be modified further with additional flex properties.</p>
              <div class="d-flex p-2 bd-highlight">I'm a flexbox container!</div>
              <pre class="my-3"><code class="language-markup">&lt;div class="d-flex p-2"&gt;I'm a flexbox container!&lt;/div&gt;
</code></pre>
              <div>
                <div class="d-inline-flex p-2 bd-highlight">I'm an inline flexbox container!</div>
              </div>
              <pre class="mt-3"><code class="language-markup">&lt;div class="d-inline-flex p-2"&gt;I'm an inline flexbox container!&lt;/div&gt;
</code></pre>
              <p>Responsive variations also exist for <code>.d-flex</code> and <code>.d-inline-flex</code>.</p>
              <ul>
                <li><code>.d-flex</code></li>
                <li><code>.d-inline-flex</code></li>
                <li><code>.d-&#123;breakpoint&#125;-flex</code></li>
                <li><code>.d-&#123;breakpoint&#125;-inline-flex</code></li>
              </ul>
            </div>
          </div>

          <!--Direction-->
          <div class="card-body">
            <div class="card-text">
              <h6 id="direction" class="my-1">Direction</h6>
              <p>Set the direction of flex items in a flex container with direction utilities. In most cases you can omit the horizontal class here as the browser default is <code>row</code>. However, you may encounter situations where you needed to explicitly set this value (like responsive layouts).</p>
              <p>Use <code>.flex-row</code> to set a horizontal direction (the browser default), or <code>.flex-row-reverse</code> to start the horizontal direction from the opposite side.</p>
              <div class="d-flex flex-row bd-highlight mb-3">
                <div class="p-2 bd-highlight">Flex item 1</div>
                <div class="p-2 bd-highlight">Flex item 2</div>
                <div class="p-2 bd-highlight">Flex item 3</div>
              </div>
              <div class="d-flex flex-row-reverse bd-highlight">
                <div class="p-2 bd-highlight">Flex item 1</div>
                <div class="p-2 bd-highlight">Flex item 2</div>
                <div class="p-2 bd-highlight">Flex item 3</div>
              </div>
              <pre class="mt-3"><code class="language-markup">&lt;div class="d-flex flex-row"&gt;
    &lt;div class="p-2"&gt;Flex item 1&lt;/div&gt;
    &lt;div class="p-2"&gt;Flex item 2&lt;/div&gt;
    &lt;div class="p-2"&gt;Flex item 3&lt;/div&gt;
&lt;/div&gt;
&lt;div class="d-flex flex-row-reverse"&gt;
    &lt;div class="p-2"&gt;Flex item 1&lt;/div&gt;
    &lt;div class="p-2"&gt;Flex item 2&lt;/div&gt;
    &lt;div class="p-2"&gt;Flex item 3&lt;/div&gt;
&lt;/div&gt;
</code></pre>
              <p>Use <code>.flex-column</code> to set a vertical direction, or <code>.flex-column-reverse</code> to start the vertical direction from the opposite side.</p>
              <div class="d-flex flex-column bd-highlight mb-3">
                <div class="p-2 bd-highlight">Flex item 1</div>
                <div class="p-2 bd-highlight">Flex item 2</div>
                <div class="p-2 bd-highlight">Flex item 3</div>
              </div>
              <div class="d-flex flex-column-reverse bd-highlight">
                <div class="p-2 bd-highlight">Flex item 1</div>
                <div class="p-2 bd-highlight">Flex item 2</div>
                <div class="p-2 bd-highlight">Flex item 3</div>
              </div>
              <pre class="mt-3"><code class="language-markup">&lt;div class="d-flex flex-column"&gt;
    &lt;div class="p-2"&gt;Flex item 1&lt;/div&gt;
    &lt;div class="p-2"&gt;Flex item 2&lt;/div&gt;
    &lt;div class="p-2"&gt;Flex item 3&lt;/div&gt;
&lt;/div&gt;
&lt;div class="d-flex flex-column-reverse"&gt;
    &lt;div class="p-2"&gt;Flex item 1&lt;/div&gt;
    &lt;div class="p-2"&gt;Flex item 2&lt;/div&gt;
    &lt;div class="p-2"&gt;Flex item 3&lt;/div&gt;
&lt;/div&gt;
</code></pre>
              <p>Responsive variations also exist for <code>flex-direction</code>.</p>
              <ul>
                <li><code>.flex-&#123;row/column&#125;</code></li>
                <li><code>.flex-&#123;row-reverse/column-reverse&#125;</code></li>
                <li><code>.flex-&#123;breakpoint&#125;-&#123;row/column&#125;</code></li>
                <li><code>.flex-&#123;breakpoint&#125;-&#123;row-reverse/column-reverse&#125;</code></li>
              </ul>
            </div>
          </div>

          <!--Justify content-->
          <div class="card-body">
            <div class="card-text">
              <h6 id="justify-content" class="my-1">Justify content</h6>
              <p>Use <code>justify-content</code> utilities on flexbox containers to change the alignment of flex items on the main axis (the x-axis to start, y-axis if <code>flex-direction: column</code>). Choose from <code>start</code> (browser default), <code>end</code>, <code>center</code>, <code>between</code>, or <code>around</code>.</p>
              <div class="d-flex justify-content-start bd-highlight mb-3">
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
              </div>
              <div class="d-flex justify-content-end bd-highlight mb-3">
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
              </div>
              <div class="d-flex justify-content-center bd-highlight mb-3">
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
              </div>
              <div class="d-flex justify-content-between bd-highlight mb-3">
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
              </div>
              <div class="d-flex justify-content-around bd-highlight">
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
              </div>
              <pre class="mt-3"><code class="language-markup">&lt;div class="d-flex justify-content-start"&gt;...&lt;/div&gt;
&lt;div class="d-flex justify-content-end"&gt;...&lt;/div&gt;
&lt;div class="d-flex justify-content-center"&gt;...&lt;/div&gt;
&lt;div class="d-flex justify-content-between"&gt;...&lt;/div&gt;
&lt;div class="d-flex justify-content-around"&gt;...&lt;/div&gt;
</code></pre>
              <p>Responsive variations also exist for <code>justify-content</code>.</p>
              <ul>
                <li><code>.justify-content-start</code></li>
                <li><code>.justify-content-end</code></li>
                <li><code>.justify-content-center</code></li>
                <li><code>.justify-content-between</code></li>
                <li><code>.justify-content-around</code></li>
                <li><code>.justify-content-&#123;breakpoint&#125;-&#123;start/end/center/between/around&#125;</code>
                </li>
              </ul>
            </div>
          </div>

          <!--Align items-->
          <div class="card-body">
            <div class="card-text">
              <h6 id="align-items" class="my-1">Align items</h6>
              <p>Use <code>align-items</code> utilities on flexbox containers to change the alignment of flex items on the cross axis (the y-axis to start, x-axis if <code>flex-direction: column</code>). Choose from <code>start</code>, <code>end</code>, <code>center</code>, <code>baseline</code>, or <code>stretch</code> (browser default).</p>
              <div class="d-flex align-items-start bd-highlight mb-3" style="height: 100px">
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
              </div>
              <div class="d-flex align-items-end bd-highlight mb-3" style="height: 100px">
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
              </div>
              <div class="d-flex align-items-center bd-highlight mb-3" style="height: 100px">
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
              </div>
              <div class="d-flex align-items-baseline bd-highlight mb-3" style="height: 100px">
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
              </div>
              <div class="d-flex align-items-stretch bd-highlight" style="height: 100px">
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
              </div>
              <pre class="mt-3"><code class="language-markup">&lt;div class="d-flex align-items-start"&gt;...&lt;/div&gt;
&lt;div class="d-flex align-items-end"&gt;...&lt;/div&gt;
&lt;div class="d-flex align-items-center"&gt;...&lt;/div&gt;
&lt;div class="d-flex align-items-baseline"&gt;...&lt;/div&gt;
&lt;div class="d-flex align-items-stretch"&gt;...&lt;/div&gt;
</code></pre>
              <p>Responsive variations also exist for <code>align-items</code>.</p>
              <ul>
                <li><code>.align-items-start</code></li>
                <li><code>.align-items-end</code></li>
                <li><code>.align-items-center</code></li>
                <li><code>.align-items-baseline</code></li>
                <li><code>.align-items-stretch</code></li>
                <li><code>.align-items-&#123;breakpoint&#125;-&#123;start/end/center/baseline/stretch&#125;</code>
                </li>
              </ul>
            </div>
          </div>

          <!--Align self-->
          <div class="card-body">
            <div class="card-text">
              <h6 id="align-self" class="my-1">Align self</h6>
              <p>Use <code>align-self</code> utilities on flexbox items to individually change their alignment on the cross axis (the y-axis to start, x-axis if <code>flex-direction: column</code>). Choose from the same options as <code>align-items</code>: <code>start</code>, <code>end</code>, <code>center</code>, <code>baseline</code>, or <code>stretch</code> (browser default).</p>
              <div class="d-flex bd-highlight mb-3" style="height: 100px">
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="align-self-start p-2 bd-highlight">Aligned flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
              </div>
              <div class="d-flex bd-highlight mb-3" style="height: 100px">
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="align-self-end p-2 bd-highlight">Aligned flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
              </div>
              <div class="d-flex bd-highlight mb-3" style="height: 100px">
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="align-self-center p-2 bd-highlight">Aligned flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
              </div>
              <div class="d-flex bd-highlight mb-3" style="height: 100px">
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="align-self-baseline p-2 bd-highlight">Aligned flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
              </div>
              <div class="d-flex bd-highlight" style="height: 100px">
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="align-self-stretch p-2 bd-highlight">Aligned flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
              </div>
              <pre class="mt-3"><code class="language-markup">&lt;div class="align-self-start"&gt;Aligned flex item&lt;/div&gt;
&lt;div class="align-self-end"&gt;Aligned flex item&lt;/div&gt;
&lt;div class="align-self-center"&gt;Aligned flex item&lt;/div&gt;
&lt;div class="align-self-baseline"&gt;Aligned flex item&lt;/div&gt;
&lt;div class="align-self-stretch"&gt;Aligned flex item&lt;/div&gt;
</code></pre>
              <p>Responsive variations also exist for <code>align-self</code>.</p>
              <ul>
                <li><code>.align-self-start</code></li>
                <li><code>.align-self-end</code></li>
                <li><code>.align-self-center</code></li>
                <li><code>.align-self-baseline</code></li>
                <li><code>.align-self-stretch</code></li>
                <li><code>.align-self-&#123;breakpoint&#125;-&#123;start/end/center/baseline/stretch&#125;</code></li>
              </ul>
            </div>
          </div>

          <!--Auto margins-->
          <div class="card-body">
            <div class="card-text">
              <h6 id="align-self-margin" class="my-1">Auto margins</h6>
              <p>Flexbox can do some pretty awesome things when you mix flex alignments with auto margins. Shown below are three examples of controlling flex items via auto margins: default (no auto margin), pushing two items to the right (<code>.mr-auto</code>), and pushing two items to the left (<code>.ml-auto</code>).</p>
              <p><strong>Unfortunately, IE10 and IE11 do not properly support auto margins on flex items whose parent has a
                  non-default <code>justify-content</code> value.</strong><a
                  href="https://stackoverflow.com/a/37535548">See this StackOverflow answer</a> for more details.</p>
              <div class="d-flex bd-highlight mb-3">
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
              </div>
              <div class="d-flex bd-highlight mb-3">
                <div class="mr-auto p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
              </div>
              <div class="d-flex bd-highlight mb-3">
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="ml-auto p-2 bd-highlight">Flex item</div>
              </div>
              <pre class="language-markup"><code class="language-markup">&lt;div class="d-flex"&gt;
    &lt;div class="p-2"&gt;Flex item&lt;/div&gt;
    &lt;div class="p-2"&gt;Flex item&lt;/div&gt;
    &lt;div class="p-2"&gt;Flex item&lt;/div&gt;
&lt;/div&gt;

&lt;div class="d-flex"&gt;
    &lt;div class="mr-auto p-2"&gt;Flex item&lt;/div&gt;
    &lt;div class="p-2"&gt;Flex item&lt;/div&gt;
    &lt;div class="p-2"&gt;Flex item&lt;/div&gt;
&lt;/div&gt;

&lt;div class="d-flex"&gt;
    &lt;div class="p-2"&gt;Flex item&lt;/div&gt;
    &lt;div class="p-2"&gt;Flex item&lt;/div&gt;
    &lt;div class="ml-auto p-2"&gt;Flex item&lt;/div&gt;
&lt;/div&gt;
</code></pre>
            </div>
          </div>

          <!--With align-items-->
          <div class="card-body">
            <div class="card-text">
              <h6 id="with-align-items" class="my-1">With align-items</h6>
              <p>Vertically move one flex item to the top or bottom of a container by mixing <code>align-items</code>, <code>flex-direction: column</code>, and <code>margin-top: auto</code> or <code>margin-bottom: auto</code>.</p>
              <div class="d-flex align-items-start flex-column bd-highlight mb-3" style="height: 200px;">
                <div class="mb-auto p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
              </div>
              <div class="d-flex align-items-end flex-column bd-highlight mb-3" style="height: 200px;">
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="mt-auto p-2 bd-highlight">Flex item</div>
              </div>
              <pre class="language-markup"><code class="language-markup">&lt;div class="d-flex align-items-start flex-column" style="height: 200px;"&gt;
    &lt;div class="mb-auto p-2"&gt;Flex item&lt;/div&gt;
    &lt;div class="p-2"&gt;Flex item&lt;/div&gt;
    &lt;div class="p-2"&gt;Flex item&lt;/div&gt;
&lt;/div&gt;

&lt;div class="d-flex align-items-end flex-column" style="height: 200px;"&gt;
    &lt;div class="p-2"&gt;Flex item&lt;/div&gt;
    &lt;div class="p-2"&gt;Flex item&lt;/div&gt;
    &lt;div class="mt-auto p-2"&gt;Flex item&lt;/div&gt;
&lt;/div&gt;
</code></pre>
            </div>
          </div>

          <!--Wrap-->
          <div class="card-body">
            <div class="card-text">
              <h6 id="wrap" class="my-1">Wrap</h6>
              <p>Change how flex items wrap in a flex container. Choose from no wrapping at all (the browser default) with <code>.flex-nowrap</code>, wrapping with <code>.flex-wrap</code>, or reverse wrapping with <code>.flex-wrap-reverse</code>.</p>
              <div class="d-flex flex-nowrap bd-highlight w-25">
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
              </div>
              <pre class="my-3"><code class="language-markup">&lt;div class="d-flex flex-nowrap"&gt;
    ...
&lt;/div&gt;
</code></pre>

              <div class="d-flex flex-wrap bd-highlight">
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
              </div>
              <pre class="my-3"><code class="language-markup">&lt;div class="d-flex flex-wrap"&gt;
    ...
&lt;/div&gt;
</code></pre>

              <div class="d-flex flex-wrap-reverse bd-highlight">
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
              </div>
              <pre class="mt-3"><code class="language-markup">&lt;div class="d-flex flex-wrap-reverse"&gt;
    ...
&lt;/div&gt;
</code></pre>
              <p>Responsive variations also exist for <code>flex-wrap</code>.</p>
              <ul>
                <li><code>.flex-nowrap</code></li>
                <li><code>.flex-wrap</code></li>
                <li><code>.flex-wrap-reverse</code></li>
                <li><code>.flex-&#123;breakpoint&#125;-&#123;nowrap/wrap/wrap-reverse&#125;</code></li>
                <li><code>.flex-sm-wrap</code></li>
                <li><code>.flex-sm-wrap-reverse</code></li>
              </ul>
            </div>
          </div>

          <!--Order-->
          <div class="card-body">
            <div class="card-text">
              <h6 id="order" class="my-1">Order</h6>
              <p>Change the <em>visual</em> order of specific flex items with a handful of <code>order</code> utilities. We only provide options for making an item first or last, as well as a reset to use the DOM order. As <code>order</code> takes any integer value (e.g., <code>5</code>), add custom CSS for any additional values needed.</p>
              <div class="d-flex flex-nowrap bd-highlight">
                <div class="order-3 p-2 bd-highlight">First flex item</div>
                <div class="order-2 p-2 bd-highlight">Second flex item</div>
                <div class="order-1 p-2 bd-highlight">Third flex item</div>
              </div>
              <pre class="mt-3"><code class="language-markup">&lt;div class="d-flex flex-nowrap"&gt;
    &lt;div class="order-3 p-2"&gt;First flex item&lt;/div&gt;
    &lt;div class="order-2 p-2"&gt;Second flex item&lt;/div&gt;
    &lt;div class="order-1 p-2"&gt;Third flex item&lt;/div&gt;
&lt;/div&gt;
</code></pre>
              <p>Responsive variations also exist for <code>order</code>.</p>
              <ul>
                <li><code>.order-&#123;value&#125;</code></li>
                <li><code>.order-&#123;breakpoint&#125;-&#123;value&#125;</code></li>
              </ul>
            </div>
          </div>

          <!--Align content-->
          <div class="card-body">
            <div class="card-text">
              <h6 id="align-content" class="my-1">Align content</h6>
              <p>Use <code>align-content</code> utilities on flexbox containers to align flex items <em>together</em> on the cross axis. Choose from <code>start</code> (browser default), <code>end</code>, <code>center</code>, <code>between</code>, <code>around</code>, or <code>stretch</code>. To demonstrate these utilities, we’ve enforced <code>flex-wrap: wrap</code> and increased the number of flex items.</p>
              <p><strong>Heads up!</strong> This property has no effect on single rows of flex items.</p>
              <div class="d-flex align-content-start flex-wrap bd-highlight mb-3" style="height: 200px">
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
              </div>

              <pre class="language-markup"><code class="language-markup">&lt;div class="d-flex align-content-start flex-wrap"&gt;
    ...
&lt;/div&gt;
</code></pre>

              <div class="d-flex align-content-end flex-wrap bd-highlight my-3" style="height: 200px">
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
              </div>

              <pre class="language-markup"><code class="language-markup">&lt;div class="d-flex align-content-end flex-wrap"&gt;
    ...
&lt;/div&gt;
</code></pre>

              <div class="d-flex align-content-center flex-wrap bd-highlight my-3" style="height: 200px">
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
              </div>
              <pre class="language-markup"><code class="language-markup">&lt;div class="d-flex align-content-center flex-wrap"&gt;
    ...
&lt;/div&gt;
</code></pre>

              <div class="d-flex align-content-between flex-wrap bd-highlight my-3" style="height: 200px">
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
              </div>
              <pre class="language-markup"><code class="language-markup">&lt;div class="d-flex align-content-between flex-wrap"&gt;
    ...
&lt;/div&gt;
</code></pre>

              <div class="d-flex align-content-around flex-wrap bd-highlight my-3" style="height: 200px">
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
              </div>
              <pre class="language-markup"><code class="language-markup">&lt;div class="d-flex align-content-around flex-wrap"&gt;
    ...
&lt;/div&gt;
</code></pre>

              <div class="d-flex align-content-stretch flex-wrap bd-highlight my-3" style="height: 200px">
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
                <div class="p-2 bd-highlight">Flex item</div>
              </div>
              <pre class="language-markup"><code class="language-markup">&lt;div class="d-flex align-content-stretch flex-wrap"&gt;
    ...
&lt;/div&gt;
</code></pre>
              <p>Responsive variations also exist for <code>align-content</code>.</p>
              <ul>
                <li><code>.align-content-start</code></li>
                <li><code>.align-content-end</code></li>
                <li><code>.align-content-center</code></li>
                <li><code>.align-content-around</code></li>
                <li><code>.align-content-stretch</code></li>
                <li><code>.align-content-&#123;breakpoint&#125;-&#123;start/end/center/around/stretch&#125;</code>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--/Flex-->

<!--Float-->
<section id="Float">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Float</h4>
        </div>
        <div class="card-content">
          <!--Overview-->
          <div class="card-body">
            <div class="card-text">
              <p class="bd-lead">Toggle floats on any element, across any breakpoint, using our responsive float utilities.</p>
              <p>These utility classes float an element to the left or right, or disable floating, based on the current viewport size using the <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/float" target="_blank">CSS <code>float</code> property</a>. <code>!important</code> is included to avoid specificity issues. These use the same viewport breakpoints as our grid system.</p>
              <p>Toggle a float with a class:</p>
              <div class="mb-3">
                <div class="float-left">Float left on all viewport sizes</div><br>
                <div class="float-right">Float right on all viewport sizes</div><br>
                <div class="float-none">Don't float on all viewport sizes</div>
              </div>
              <pre class="language-markup"><code class="language-markup">&lt;div class="float-left"&gt;Float left on all viewport sizes&lt;/div&gt;&lt;br&gt;
&lt;div class="float-right"&gt;Float right on all viewport sizes&lt;/div&gt;&lt;br&gt;
&lt;div class="float-none"&gt;Don't float on all viewport sizes&lt;/div&gt;
</code></pre>
              <h6 id="float-responsive" class="my-1">Responsive</h6>
              <p>Responsive variations also exist for each <code>float</code> value.</p>
              <div class="mb-3">
                <div class="float-sm-left">Float left on viewports sized SM (small) or wider</div><br>
                <div class="float-md-left">Float left on viewports sized MD (medium) or wider</div><br>
                <div class="float-lg-left">Float left on viewports sized LG (large) or wider</div><br>
                <div class="float-xl-left">Float left on viewports sized XL (extra-large) or wider</div><br>
              </div>
              <pre class="language-markup"><code class="language-markup">&lt;div class="float-sm-left"&gt;Float left on viewports sized SM (small) or wider&lt;/div&gt;&lt;br&gt;
&lt;div class="float-md-left"&gt;Float left on viewports sized MD (medium) or wider&lt;/div&gt;&lt;br&gt;
&lt;div class="float-lg-left"&gt;Float left on viewports sized LG (large) or wider&lt;/div&gt;&lt;br&gt;
&lt;div class="float-xl-left"&gt;Float left on viewports sized XL (extra-large) or wider&lt;/div&gt;&lt;br&gt;
</code></pre>
              <p>Here are all the support classes;</p>
              <ul>
                <li><code>.float-&#123;left/right/none&#125;</code></li>
                <li><code>.float-&#123;breakpoint&#125;-&#123;left/right/none&#125;</code></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--Image replacement-->
<section id="image-replacement">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Image replacement</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="card-text">
              <p>Swap text for background images with the image replacement class.</p>
              <p>Utilize the <code>.text-hide</code> class or mixin to help replace an element’s text content with a background image.</p>
              <pre class="language-markup"><code class="language-markup">&lt;h1 class="text-hide"&gt;Custom heading&lt;/h1&gt;
</code></pre>
              <p>Use the <code>.text-hide</code> class to maintain the accessibility and SEO benefits of heading tags, but want to utilize a <code>background-image</code> instead of text.</p>
              <div>
                <h1 class="text-hide my-2"
                  style="background-image: url('assets/img/portrait/small/avatar-s-1.png'); width: 30px; height: 30px;">
                  Bootstrap</h1>
              </div>
              <pre class="language-markup"><code class="language-markup">&lt;h1 class="text-hide my-2" style="background-image: url('assets/img/portrait/small/avatar-s-1.png'); width: 30px; height: 30px;"&gt;Bootstrap&lt;/h1&gt;
</code></pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--/Image replacement-->

<!--position-->
<section id="display-position">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Position</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="card-text">
              <p>Use these shorthand utilities for quickly configuring the position of an element.</p>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>Classes</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>.position-fixed</code></td>
                  <td>Changes element's position to fixed.</td>
                </tr>
                <tr>
                  <td><code>.position-relative</code></td>
                  <td>Changes element's position to relative.</td>
                </tr>
                <tr>
                  <td><code>.position-absolute</code></td>
                  <td>Changes element's position to absolute.</td>
                </tr>
                <tr>
                  <td><code>.position-static</code></td>
                  <td>Changes element's position to static.</td>
                </tr>
                <tr>
                  <td><code>.position-sticky</code></td>
                  <td>Changes element's position to static.</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-body">
            <div class="card-text">
              <h6 class="mb-1">Fixed top</h6>
              <p>Position an element at the top of the viewport, from edge to edge. Be sure you understand the ramifications of fixed position in your project; you may need to add aditional CSS.</p>
              <pre class="language-markup"><code class="language-markup">&lt;div class="fixed-top"&gt;...&lt;/div&gt;
</code></pre>
            </div>
          </div>
          <div class="card-body">
            <div class="card-text">
              <h6 class="mb-1">Fixed bottom</h6>
              <p>Position an element at the bottom of the viewport, from edge to edge. Be sure you understand the ramifications of fixed position in your project; you may need to add aditional CSS.</p>
              <pre class="language-markup"><code class="language-markup">&lt;div class="fixed-footer"&gt;...&lt;/div&gt;
</code></pre>
            </div>
          </div>
          <div class="card-body">
            <div class="card-text">
              <h6 class="mb-1">Sticky top</h6>
              <p>Position an element at the top of the viewport, from edge to edge, but only after you scroll past it. The <code>.sticky-top</code> utility uses CSS’s <code>position: sticky</code>, which isn’t fully supported in all browsers.</p>
              <p><strong>Microsoft Edge and IE11 will render <code>position: sticky</code> as <code>position: relative</code>.</strong> As such, we wrap the styles in a <code>@supports</code> query, limiting the stickiness to only browsers that properly can render it.</p>
              <pre class="language-markup"><code class="language-markup">&lt;div class="sticky-top"&gt;...&lt;/div&gt;
</code></pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--/position-->

<!--Screenreaders-->
<section id="screenreaders">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Screenreaders</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="card-text">
              <p>Use screenreader utilities to hide elements on all devices except screen readers.</p>
              <p>Hide an element to all devices <strong>except screen readers</strong> with <code>.sr-only</code>. Combine <code>.sr-only</code> with <code>.sr-only-focusable</code> to show the element again when it’s focused (e.g. by a keyboard-only user). Can also be used as mixins.</p>
              <pre class="language-markup"><code class="language-markup">&lt;a class="sr-only sr-only-focusable" href="#content"&gt;Skip to main content&lt;/a&gt;
</code></pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--/ Screenreaders-->

<!--Sizing-->
<section id="sizing">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Sizing</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="card-text">
              <p>Easily make an element as wide or as tall (relative to its parent) with our width and height utilities.</p>
              <p>Width and height utilities are generated from the <code>$sizes</code> in <code>_variables.scss</code>. Includes support for <code>25%</code>, <code>50%</code>, <code>75%</code>, and <code>100%</code> by default. Modify those values as you need to generate different utilities here.</p>
              <div>
                <div class="w-25 width-example p-3">Width 25%</div>
                <div class="w-50 width-example p-3">Width 50%</div>
                <div class="w-75 width-example p-3">Width 75%</div>
                <div class="w-100 width-example p-3">Width 100%</div>
              </div>
              <pre class="my-3"><code class="language-markup">&lt;div class="w-25 p-3"&gt;Width 25%&lt;/div&gt;
&lt;div class="w-50 p-3"&gt;Width 50%&lt;/div&gt;
&lt;div class="w-75 p-3"&gt;Width 75%&lt;/div&gt;
&lt;div class="w-100 p-3"&gt;Width 100%&lt;/div&gt;
</code></pre>
              <div class="height-example-wrapper">
                <div class="h-25 height-example d-inline-block">Height 25%</div>
                <div class="h-50 height-example d-inline-block">Height 50%</div>
                <div class="h-75 height-example d-inline-block">Height 75%</div>
                <div class="h-100 height-example d-inline-block">Height 100%</div>
              </div>
              <pre class="my-3"><code class="language-markup">&lt;div&gt;
    &lt;div class="h-25 d-inline-block"&gt;Height 25%&lt;/div&gt;
    &lt;div class="h-50 d-inline-block"&gt;Height 50%&lt;/div&gt;
    &lt;div class="h-75 d-inline-block"&gt;Height 75%&lt;/div&gt;
    &lt;div class="h-100 d-inline-block"&gt;Height 100%&lt;/div&gt;
&lt;/div&gt;
</code></pre>
              <p>You can also use <code>max-width: 100%;</code> and <code>max-height: 100%;</code> utilities as needed.</p>
              <div>
                <img class="mw-100" data-src="holder.js/1000px100?text=Max-width%20%3D%20100%25" alt="Max-width = 100% [1000%x100]" style="height: 100px; width: 1000%; display: block;" src="data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22782%22%20height%3D%22100%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20782%20100%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_15fc00274c0%20text%20%7B%20fill%3Argba(255%2C255%2C255%2C.75)%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A39pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_15fc00274c0%22%3E%3Crect%20width%3D%22782%22%20height%3D%22100%22%20fill%3D%22%23777%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%22176.3984375%22%20y%3D%2267.4%22%3EMax-width%20%3D%20100%25%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E" data-holder-rendered="true">
              </div>
              <pre class="my-3"><code class="language-markup">&lt;img class="mw-100" src="..." alt="Max-width 100%"&gt;
</code></pre>
              <div class="height-example-wrapper">
                <div class="mh-100 height-example" style="width: 100px; height: 200px;">Max-height 100%</div>
              </div>
              <pre class="mt-3"><code class="language-markup">&lt;div&gt;
    &lt;div class="mh-100" style="width: 100px; height: 200px; background-color: rgba(0,0,255,0.1);"&gt;Max-height 100%&lt;/div&gt;
&lt;/div&gt;
</code></pre>
            </div>
          </div>
          <!--Width && Height-->
          <div class="card-body pt-0">
            <div class="card-text my-1">
              <h6 class="my-1">Width && Height</h6>
              <p>Add one of these to class to set width of the content.</p>
            </div>
          </div>
          <div class=" table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>Classes</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>.fit</code></td>
                  <td>Set content maximum width 100%.</td>
                </tr>
                <tr>
                  <td><code>.half-width</code></td>
                  <td>Set content width 50%.</td>
                </tr>
                <tr>
                  <td><code>.full-width</code></td>
                  <td>Set content width 100%.</td>
                </tr>
                <tr>
                  <td><code>.full-height</code></td>
                  <td>Set content height 100%.</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--/Width && Height-->


          <!--Fixed Width-->
          <div class="card-body pt-0">
            <div class="card-text my-1">
              <h6 class="my-1">Fixed Width</h6>
              <p>Add one of these to class to set fixed width of the content.</p>
            </div>
          </div>
          <div class=" table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>Classes</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>.width-&#123;size&#125;</code></td>
                  <td>Set content fixed width in pixel of selected size where size can be 50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700, 750 and 800. i.e <code>.width-50</code></td>
                </tr>
                <tr>
                  <td><code>.width-&#123;size&#125;-per</code></td>
                  <td>Set content fixed width in percentage of selected size where size can be 5%, 10%, 15%, 20%, 25%, 30%, 35%, 40%, 45%, 50%, 55%, 60%, 65%, 70%, 75% and 80%. i.e <code>.width-5-per</code></td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--/Fixed Width-->

          <!--Fixed Height-->
          <div class="card-body pt-0">
            <div class="card-text my-1">
              <h6 class="my-1">Fixed Height</h6>
              <p>Add one of these to class to set fixed height of the content.</p>
            </div>
          </div>
          <div class=" table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>Classes</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>.height-&#123;size&#125;</code></td>
                  <td>Set content fixed height in pixel of selected size where size can be 50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700, 750 and 800. i.e <code>.height-50</code></td>
                </tr>
                <tr>
                  <td><code>.height-&#123;size&#125;-per</code></td>
                  <td>Set content fixed height in percentage of selected size where size can be 5%, 10%, 15%, 20%, 25%, 30%, 35%, 40%, 45%, 50%, 55%, 60%, 65%, 70%, 75% and 80%. i.e <code>.height-5-per</code></td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--/Fixed Height-->
        </div>
      </div>
    </div>
  </div>
</section>
<!--/Sizing-->

<!-- Spacing -->
<section id="spacing">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Spacing</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="card-text">
              <p>Bootstrap includes a wide range of shorthand responsive margin and padding utility classes to modify an element's appearance.</p>
              <h6 class="my-1">How it works</h6>
              <p>Assign responsive-friendly <code>margin</code> or <code>padding</code> values to an element or a subset of its sides with shorthand classes. Includes support for individual properties, all properties, and vertical and horizontal properties. Classes are built from a default ranging from <code>.25rem</code> to <code>3rem</code>.</p>
              <h6 class="my-1">Notation</h6>
              <p>Spacing utilities that apply to all breakpoints, from <code>xs</code> to <code>xl</code>, have no breakpoint abbreviation in them. This is because those classes are applied from <code>min-width: 0</code> and up, and thus are not bound by a media query. The remaining breakpoints, however, do include a breakpoint abbreviation.</p>
              <p>The classes are named using the format <code>&#123;property&#125;&#123;sides&#125;-&#123;size&#125;</code> for <code>xs</code> and <code>&#123;property&#125;&#123;sides&#125;-&#123;breakpoint&#125;-&#123;size&#125;</code> for <code>sm</code>, <code>md</code>, <code>lg</code>, and <code>xl</code>.</p>
              <p>Where <code>&#123;property&#125;</code> is one of:</p>
              <ul>
                <li><code>m</code> - for classes that set <code>margin</code></li>
                <li><code>p</code> - for classes that set <code>padding</code></li>
              </ul>
              <p>Where <code>&#123;sides&#125;</code> is one of:</p>
              <ul>
                <li><code>t</code> - for classes that set <code>margin-top</code> or <code>padding-top</code></li>
                <li><code>b</code> - for classes that set <code>margin-bottom</code> or <code>padding-bottom</code></li>
                <li><code>l</code> - for classes that set <code>margin-left</code> or <code>padding-left</code></li>
                <li><code>r</code> - for classes that set <code>margin-right</code> or <code>padding-right</code></li>
                <li><code>x</code> - for classes that set both <code>*-left</code> and <code>*-right</code></li>
                <li><code>y</code> - for classes that set both <code>*-top</code> and <code>*-bottom</code></li>
                <li>blank - for classes that set a <code>margin</code> or <code>padding</code> on all 4 sides of the element</li>
              </ul>
              <p>Where <code>&#123;size&#125;</code> is one of:</p>
              <ul>
                <li><code>0</code> - for classes that eliminate the <code>margin</code> or <code>padding</code> by setting it to <code>0</code></li>
                <li><code>1</code> - (by default) for classes that set the <code>margin</code> or <code>padding</code> to <code>$spacer * .25</code></li>
                <li><code>2</code> - (by default) for classes that set the <code>margin</code> or <code>padding</code> to <code>$spacer * .5</code></li>
                <li><code>3</code> - (by default) for classes that set the <code>margin</code> or <code>padding</code> to <code>$spacer</code></li>
                <li><code>4</code> - (by default) for classes that set the <code>margin</code> or <code>padding</code> to <code>$spacer * 1.5</code></li>
                <li><code>5</code> - (by default) for classes that set the <code>margin</code> or <code>padding</code> to <code>$spacer * 3</code></li>
                <li><code>auto</code> - for classes that set the <code>margin</code> to auto</li>
              </ul>
              <p>(You can add more sizes by adding entries to the <code>$spacers</code> variable.)</p>
            </div>
          </div>
          <div class="card-body">
            <div class="card-text">
              <h6 class="my-1">Horizontal centering</h6>
              <p>Additionally, Bootstrap also includes an <code>.mx-auto</code> class for horizontally centering fixed-width block level content—that is, content that has <code>display: block</code> and a <code>width</code> set—by setting the horizontal margins to <code>auto</code>.</p>
              <div class="my-2">
                <div class="mx-auto" style="width: 200px; background-color: rgba(86,61,124,.15);">Centered element</div>
              </div>
              <pre class="language-markup"><code class="language-markup">&lt;div class="mx-auto" style="width: 200px;"&gt;
    Centered element
&lt;/div&gt;
</code></pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--/ Spacing -->

<!--vertical alignment-->
<section id="vertical-alignment">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Vertical alignment</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="card-text">
              <p>Easily change the vertical alignment of inline, inline-block, inline-table, and table cell elements.</p>
              <p>Change the alignment of elements with the <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/vertical-align"><code>vertical-alignment</code></a> utilities. Please note that vertical-align only affects inline, inline-block, inline-table, and table cell elements.</p>
              <p>Choose from <code>.align-baseline</code>, <code>.align-top</code>, <code>.align-middle</code>, <code>.align-bottom</code>, <code>.align-text-top</code>, and <code>.align-text-bottom</code> as needed.</p>
              <div>
                <span class="align-baseline">baseline</span>
                <span class="align-top">top</span>
                <span class="align-middle">middle</span>
                <span class="align-bottom">bottom</span>
                <span class="align-text-top">text-top</span>
                <span class="align-text-bottom">text-bottom</span>
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>Classes</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>.align-&#123;direction&#125;</code></td>
                  <td>Changes element's vertical alignment to mentioned direction (top, middle, bottom, baseline).</td>
                </tr>
                <tr>
                  <td><code>.align-text-&#123;top/bottom&#125;</code></td>
                  <td>Top of the element is aligned with the top / bottom of the parent element's font.</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-body">
            <div class="card-text">
              <p>With table cells:</p>
              <table style="height: 100px;">
                <tbody>
                  <tr>
                    <td class="align-baseline">baseline</td>
                    <td class="align-top">top</td>
                    <td class="align-middle">middle</td>
                    <td class="align-bottom">bottom</td>
                    <td class="align-text-top">text-top</td>
                    <td class="align-text-bottom">text-bottom</td>
                  </tr>
                </tbody>
              </table>
              <pre class="language-markup"><code class="language-markup">&lt;table style="height: 100px;"&gt;
    &lt;tbody&gt;
        &lt;tr&gt;
            &lt;td class="align-baseline"&gt;baseline&lt;/td&gt;
            &lt;td class="align-top"&gt;top&lt;/td&gt;
            &lt;td class="align-middle"&gt;middle&lt;/td&gt;
            &lt;td class="align-bottom"&gt;bottom&lt;/td&gt;
            &lt;td class="align-text-top"&gt;text-top&lt;/td&gt;
            &lt;td class="align-text-bottom"&gt;text-bottom&lt;/td&gt;
        &lt;/tr&gt;
    &lt;/tbody&gt;
&lt;/table&gt;</code></pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--/vertical alignment-->

<!--Image-->
<section id="image">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Image</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="card-text">
              <p>Add one of these to class to change image size and other property.</p>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table mb-0">
              <thead>
                <tr>
                  <th>Classes</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>.bg-cover</code></td>
                  <td>Scale the background image to be as large as possible so that the background area is completely covered by the background image.</td>
                </tr>
                <tr>
                  <td><code>.background-repeat</code></td>
                  <td>Repeat the background image.</td>
                </tr>
                <tr>
                  <td><code>.background-no-repeat</code></td>
                  <td>Do not repeat the background image.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--/Image-->

<!--/Content helpers-->
<section id="content-helpers">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Content helpers</h4>
        </div>
        <div class="card-content">
          <!--z-index-->
          <div class="card-body">
            <div class="card-text">
              <h6 class="my-1">z-index</h6>
              <p>Add one of these classes to change the elemets' z-index properties.</p>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>Classes</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>.zindex-minus-&#123;1/2/3/4&#125;</code></td>
                  <td>Set element's z-index value minus 1/2/3/4.</td>
                </tr>
                <tr>
                  <td><code>.zindex-&#123;1/2/3/4&#125;</code></td>
                  <td>Set element's z-index value 1/2/3/4.</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--/z-index-->

          <!--Cursors-->
          <div class="card-body">
            <div class="card-text">
              <h6 class="my-1">Cursors</h6>
              <p>Add one of these to class to change cursor style.</p>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>Classes</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>.cursor-pointer</code></td>
                  <td>The cursor is a pointer and indicates a link. Useful for user interaction feedback.</td>
                </tr>
                <tr>
                  <td><code>.cursor-move</code></td>
                  <td>The cursor indicates something is to be moved. Used in shortable components</td>
                </tr>
                <tr>
                  <td><code>.cursor-default</code></td>
                  <td>Set cursor to browser default style.</td>
                </tr>
                <tr>
                  <td><code>.cursor-progress</code></td>
                  <td>The cursor indicates that the program is busy (in progress).</td>
                </tr>
                <tr>
                  <td><code>.cursor-not-allowed</code></td>
                  <td>The cursor indicates that the requested action will not be executed.</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--/Cursors-->

          <!--Overflow-->
          <div class="card-body">
            <div class="card-text">
              <h6 class="my-1">Overflow</h6>
              <p>Add one of these to class to change overflow of element.</p>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>Classes</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>.overflow-visible</code></td>
                  <td>Default. The overflow is not clipped. It renders outside the element's box.</td>
                </tr>
                <tr>
                  <td><code>.overflow-hidden</code></td>
                  <td>The overflow is clipped, and the rest of the content will be invisible.</td>
                </tr>
                <tr>
                  <td><code>.overflow-auto</code></td>
                  <td>If overflow is clipped, a scrollbar should be added to see the rest of the content.</td>
                </tr>
                <tr>
                  <td><code>.overflow-scroll</code></td>
                  <td>The overflow is clipped, but a scrollbar is added to see the rest of the content.</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!--List-->
          <div class="card-body">
            <div class="card-text my-1">
              <h6 class="my-1">List</h6>
              <p>Add one of these to class to change list style.</p>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>Classes</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>.list-unstyled</code></td>
                  <td>No marker is shown in the list item.</td>
                </tr>
                <tr>
                  <td><code>.bullets-inside</code></td>
                  <td>Indents the marker and the text. The bullets appear inside the content flow</td>
                </tr>
                <tr>
                  <td><code>.list-style-circle</code></td>
                  <td>Set the list item marker to circle.</td>
                </tr>
                <tr>
                  <td><code>.list-style-square</code></td>
                  <td>Set the list item marker to square.</td>
                </tr>
                <tr>
                  <td><code>.list-style-icons</code></td>
                  <td>Set the list item marker with icons.</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--List-->

        </div>
      </div>
    </div>
  </div>
</section>
<!--/ Content helpers-->

<!--Visibility-->
<section id="visibility">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Visibility</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="card-text">
              <p>Control the visibility, without modifying the display, of elements with visibility utilities.</p>
              <p>Set the <code>visibility</code> of elements with our visibility utilities. These do not modify the <code>display</code> value at all and are helpful for hiding content from most users, but still keeping them for screen readers.</p>
              <p>Apply <code>.visible</code> or <code>.invisible</code> as needed.</p>
              <pre class="language-markup"><code class="language-markup">&lt;div class="visible"&gt;...&lt;/div&gt;
&lt;div class="invisible"&gt;...&lt;/div&gt;
</code></pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--/ visibility-->
